module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Medium.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Medium.woff2
// module id = 68
// module chunks = 8